import { render, staticRenderFns } from "./TunnelConfigurationForm.vue?vue&type=template&id=0ed7f2a6&"
import script from "./TunnelConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./TunnelConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports